import React, { useEffect, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  Controller,
  Thumbs
} from 'swiper'
import style from './styles/lifehack_modal.module.scss'
import { api } from '@/api'
import { useModal } from '@/hooks'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

SwiperCore.use([Autoplay, Navigation, Pagination, Controller, Thumbs])

const LifehackModal = (): React.ReactElement => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const [data, setData] = useState<any>([])
  const { modalProps } = useModal()

  const slideTime = 8000

  const pagination = {
    clickable: true,
    renderBullet: function (index: number|string, className: string) {
      return `
        <div class='${className}'>
          <div
            class='${className}-fill'
            style='animation-duration:${slideTime}ms'
            data-index='${index}'
            data-viewed='${String(index <= currentSlideIndex)}'
          ></div>
        </div>
      `
    }
  }

  useEffect(() => {
    api
      .getLifeHack({ id: modalProps.lifehackId })
      .then((data) => {
        setData(data?.property_elements_value ?? [])
      })
      .catch((error) => console.log(error))
  }, [modalProps.lifehackId])

  return (
    <div className={style.modal_wrap}>
      <Swiper
        pagination={pagination}
        autoplay={{
          delay: slideTime,
          disableOnInteraction: false,
          stopOnLastSlide: true,
          waitForTransition: false
        }}
        watchSlidesProgress
        slidesPerView={1}
        spaceBetween={0}
        resizeObserver
        onActiveIndexChange={(swiper) => {
          setCurrentSlideIndex(swiper.realIndex)
          swiper.pagination.render()
          swiper.pagination.update()
        }}
      >
        {data.length === 0
          ? (
            <SwiperSlide>
              <PlaceholderLoading shape='rect' width='100%' height='100%' />
            </SwiperSlide>
            )
          : (
              data.map((el) => {
                return (
                  <SwiperSlide key={el.id}>
                    <img
                      src={el.preview_picture[0] ?? ''}
                      className={style.modal__image}
                    />
                  </SwiperSlide>
                )
              })
            )}
      </Swiper>
    </div>
  )
}

export default LifehackModal
